export interface IToolboxState {
    showBtns: true
    isFullscreen: boolean
    showMap: boolean
    showAttachments:boolean
    showFx: boolean
    showMeasureButtons: boolean
    showSaveButton:boolean
}
export const initialToolboxState =
    (): IToolboxState => ({
        showBtns: true,
        isFullscreen: false,
        showMap: true,
        showAttachments: false,
        showFx: false,
        showMeasureButtons: false,
        showSaveButton: false
    })
